const applicant = function() {

    $(document).on('click', '#showDateInfo', function() {
        $('#dateinfo').toggle();
    });
};

export default applicant;
